import { RadioGroup_Field_default } from "./chunk-KBXZVDMR.js";
import { RadioGroup_default } from "./chunk-NRQONWLH.js";
import { CheckableGroup_MoreButton_default } from "./chunk-LGNOJ3DG.js";

// src/components/RadioGroup/index.ts
var RadioGroupComponent = RadioGroup_default;
RadioGroupComponent.Field = RadioGroup_Field_default;
RadioGroupComponent.Field.displayName = "RadioGroup.Field";
RadioGroupComponent.MoreButton = CheckableGroup_MoreButton_default;
RadioGroupComponent.MoreButton.displayName = "RadioGroup.MoreButton";
export { RadioGroupComponent };